<template>
  <div class="nt-table-wrap">
    <b-table
      :data="templates"
      :loading="isLoading"
      :hoverable="true"
      :paginated="true"
      :per-page="10"
      default-sort="updatedAt"
      default-sort-direction="desc"
    >
      <template slot-scope="props">
        <b-table-column
          field="name"
          :label="$t('admin_page.template_name')"
          sortable
        >
          {{ props.row.name }}
        </b-table-column>

        <b-table-column
          field="isActive"
          :label="$t('admin_page.template_status')"
          sortable
        >
          <b-tag :type="props.row.isActive ? 'is-success' : 'is-light'">
            {{
              props.row.isActive
                ? $t('admin_page.active')
                : $t('admin_page.archived')
            }}
          </b-tag>
        </b-table-column>

        <b-table-column
          field="updatedAt"
          :label="$t('admin_page.date_modified')"
          sortable
        >
          {{ formatDate(props.row.updatedAt) }}
        </b-table-column>

        <b-table-column :label="$t('admin_page.actions')">
          <div class="nt-actions">
            <b-button size="is-small" @click="$emit('edit', props.row)">
              {{ $t('edit') }}
            </b-button>
            <b-button
              size="is-small"
              type="is-danger"
              outlined
              @click="$emit('archive', props.row)"
              :disabled="!props.row.isActive"
            >
              {{ $t('admin_page.archive') }}
            </b-button>
          </div>
        </b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  name: 'notification-templates-table',
  props: {
    templates: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDate(value) {
      if (!value) {
        return '-';
      }
      return new Date(value).toLocaleString();
    },
  },
};
</script>

<style scoped>
.nt-actions {
  display: flex;
  gap: 8px;
}

.nt-table-wrap {
  padding: 12px;
}
</style>
